import { Box, FormLabel } from '@mui/material';
import { hasIn, isString } from 'lodash';
import React from 'react';
import { FBLabelProps, FBText } from '..';
import Colors from '../../layout/theme/utils/colors';
import { FBLabelLocaleProps } from './FBLabel.types';
import { withFBLabel } from './FBLabel.wrap';

const FBLabel: React.FunctionComponent<FBLabelProps> = ({
  label,
  error,
  loading,
  labelProps,
  ...boxProps
}) => (
  <FormLabel error={error} component="legend">
    <Box
      mb={1.25}
      fontWeight={500}
      color={Colors.dark_gray}
      {...boxProps}
    >
      {hasIn(label, 'locale') ? (
        <FBText
          loading={loading}
          labelProps={labelProps}
          locale={(label as FBLabelLocaleProps).locale}
          values={(label as FBLabelLocaleProps).values}
        />
      ) : isString(label) ? (
        <FBText
          loading={loading}
          labelProps={labelProps}
          locale={label}
        />
      ) : (
        label
      )}
    </Box>
  </FormLabel>
);

export default withFBLabel(FBLabel);
